import React from "react";
import {useLocation, useParams} from "react-router-dom";

import DateInput from "../../../formElements/DateInput";
import SelectInput from "../../../formElements/SelectInput";
import RichTextInput from "../../../formElements/RichTextInput";
import MultiFileInput from "../../../formElements/MultiFileInput";

import FormContext from "../../../support/FormContext";
import PdfContext from "../../../../reports/support/PdfContext";

import GenericForm from "../../GenericForm";


import "../../../../buttons/_static/Buttons.css";
import TwoColumnRows from "../../../formElements/TwoColumnRows";
import InstrumentLoanSection from "./InstrumentLoanSection";
import {getAppName} from "../../../../Api";
import InternalNote from "../../serviceCase/serviceCaseForm/InternalNote";
import FreeTypeSelectInput from "../../../formElements/FreeTypeSelectInput";
import PopupConfirmationWarning from "../../../../dialogs/PopupConfirmationWarning";
import {useModal} from "../../../../dialogs/ModalContext";

function LoanForm(props) {

    const {id} = useParams()
    const baseUrl = '/loan/loans/'
    const [fileData, setFileData] = React.useState([]);
    const [isSectionAdded, setIsSectionAdded] = React.useState(false)
    const pdfContext = React.useContext(PdfContext)
    const location = useLocation();
    const instrumentId = location.state?.instrumentId || null;
    const initialParams = {instrumentId: instrumentId}
    const {showModal} = useModal();

    function customSubmit(data) {
        const formData = new FormData();
        formData.append('data', data);
        fileData.forEach((file, index) => {
            if (file["newFile"] === true) {
                formData.append(`file_${index}`, file["file"]);
                formData.append(`file_${index}_print`, file["print"]);
            }
        });
        return formData
    }

    function parseFromData(data, commonParseFromData) {
        data.Prilohy = []
        data = commonParseFromData(data)
        fileData.forEach((item, index) => {
            if (item.newFile === false) {
                data.Prilohy.push({Priloha: item.file, Subor: item.file, Tlacit: item.print, id: item.id})
            }
        })
        return data
    }

    function parseData(data, commonParseData) {
        let newData = commonParseData(data)
        if (newData.id === null) {
            const appName = getAppName()
            const user = localStorage.getItem(`${appName}_user`)
            const loggedReferent = newData.Referent_options.find((item) => item.username === user)
            if (loggedReferent !== undefined) {
                newData.Referent = loggedReferent
            }
        }
        return newData
    }

    function formContent(data, update, updateCustom) {
        function selectInstrument(event, index,) {
            const newData = {...data}
            const newInstrument = data.Pristroje_options.find(
                (item) => item.SNR === event.target.value.SNR && item.Produkt.Typ === event.target.value.Produkt.Typ)
            if (index !== undefined) {
                newData.Pristroje[index].Pristroj = newInstrument
            } else {
                setIsSectionAdded(true)
                newData.Pristroje.push({
                    Pristroj: newInstrument
                })
            }
            updateCustom(newData)
        }

        function deleteInstrument(index,) {
            const newData = {...data}
            newData.Pristroje.splice(index, 1)
            updateCustom(newData)
        }

        function selectItem(event, itemIndex, newItemTemplate, itemPath, itemName,) {
            // generic function for selecting item from combobox input and handling data modification
            const newData = {...data}
            let newItem = event.target.value
            if (typeof newItem === 'string') {
                // if no item is selected but user typed something, it will return string. In that case create new item object.
                newItem = newItemTemplate
            }
            const pathsArray = itemPath.split('.')
            let fullPath = newData
            pathsArray.forEach(path => {
                fullPath = fullPath[path]
            })
            if (itemIndex !== null) {
                fullPath[itemIndex] = {
                    Cena_Ks: null,
                    Pocet: 1,
                    [itemName]: newItem
                }
            } else {
                if (event.target.value === '') {
                    return
                }
                fullPath.push({
                    Cena_Ks: null,
                    Pocet: 1,
                    [itemName]: newItem
                })
            }
            updateCustom(newData)

        }

        function updateAddress(event,) {
            let selectedAddressId = null
            if (event.target.value !== "") {
                const customerAddresses = getCurrentCustomerAddresses()
                const selectedAddress = customerAddresses.find((item) => formatAddress(item) === event.target.value)
                selectedAddressId = selectedAddress.id
            }
            const newData = {...data}
            newData.Umiestnenie = selectedAddressId
            updateCustom(newData)
        }

        function deleteLink(index,) {
            const newData = {...data}
            newData.Prilohy.splice(index, 1)
            updateCustom(newData)
        }

        function get_place(data) {
            const customerAddresses = getCurrentCustomerAddresses(data)
            if (customerAddresses.length === 0) {
                return ""
            }
            if (data.Umiestnenie === null) {
                return ""
            }
            const selectedAddress = customerAddresses.find((item) => item.id === data.Umiestnenie)
            return formatAddress(selectedAddress)
        }

        function updateCustomer(event,) {
            const newCustomer = event.target.value
            handleCustomerChange(newCustomer)
        }

        function handleCustomerChange(newCustomer) {
            const newData = {...data}
            newData.Zakaznik = newCustomer
            const customerLocations = getCustomerAddresses(newCustomer)
            if (customerLocations.length === 1) {
                newData.Umiestnenie = customerLocations[0].id
            } else {
                newData.Umiestnenie = null
            }
            updateCustom(newData)
        }

        function getPlaceOptions(data) {
            // filters addresses based on selected customer
            if (data.Zakaznik !== null && data.Zakaznik !== "") {
                const customerAddresses = getCurrentCustomerAddresses(data)
                if (customerAddresses.length === 0) {
                    return []
                }
                let newOptions = customerAddresses.map((item) => formatAddress(item))
                newOptions.unshift("")
                return newOptions
            }
            return []
        }

        function formatAddress(address) {
            return `${address.Nazov}; ${address.Mesto}; ${address.Ulica}; ${address.PSC}`
        }

        function getCurrentCustomerAddresses() {
            if (data.Zakaznik === null || data.Zakaznik === "") {
                return []
            }
            return getCustomerAddresses(data.Zakaznik)
        }

        function getCustomerAddresses(customer) {
            if (!data.Firma_Adresa_options || !customer) {
                return []
            }
            return data.Firma_Adresa_options.find((item) => item.company === customer).addresses
        }

        function getCustomerOptions() {
            if (!data.Firma_Adresa_options) {
                return []
            }
            const options = data.Firma_Adresa_options.map((item) => item.company)
            return options ? ['', ...options] : []
        }

        function getLoanTypeOptions() {
            if (!data.Typ_Zapozicky_options) {
                return []
            }
            return ["", ...data.Typ_Zapozicky_options.map((item) => item.Nazov)]
        }

        function updateLoanType(event) {
            const newData = {...data}
            newData.Typ_Zapozicky = event.target.value
            if (!data.Odhad_Vratenia) {
                const odhadVratenia = newData.Odhad_Vratenia = data.Typ_Zapozicky_options.find((item) => item.Nazov === event.target.value).Odhad_Vratenia_Dni
                if (odhadVratenia) {
                    const date = new Date()
                    date.setDate(date.getDate() + odhadVratenia)
                    newData.Odhad_Vratenia = date
                }
            }
            updateCustom(newData)
        }

        function selectReferent(event,) {
            const newVal = event.target.value
            const newData = {...data}
            if (newVal === "") {
                newData.Referent = null
            } else {
                newData.Referent = data.Referent_options.find((item) => item.username === newVal)
            }
            updateCustom(newData)
        }

        function changeNewFilePrint(index, value) {
            let updatedFileData = [...fileData]
            updatedFileData[index].print = value
            setFileData(updatedFileData)
        }

        function getReferentUsernames() {
            if (!data.Referent_options) {
                return []
            }
            return data.Referent_options.map(option => option.username)
        }

        return <>
            <FormContext.Provider value={{data: data, isSectionAdded: isSectionAdded}}>
                <label className="form-label">Číslo</label>
                <p value={data.Cislo} disabled={true} style={{"backgroundColor": "#e9ecef"}}
                   className="form-control">{data.Cislo}</p>
                <SelectInput options={['', ...getReferentUsernames()]}
                             name={'Referent'}
                             label={'Referent'}
                             value={data.Referent ? data.Referent.username : null}
                             onChange={selectReferent}/>
                <TwoColumnRows>
                    <DateInput name={'Datum_Otvorenia'} label={'Dátum Otvorenia'} value={data.Datum_Otvorenia}
                               onChange={update}/>
                    <DateInput name={'Datum_Uzavretia'} label={'Dátum Uzavretia'} value={data.Datum_Uzavretia}
                               onChange={update}/>
                    <FreeTypeSelectInput options={getCustomerOptions()} name={'Zakaznik'} label={'Zákazník'}
                                 value={data.Zakaznik} onChange={updateCustomer}/>
                    <SelectInput options={getPlaceOptions(data)} name={'Umiestnenie'} label={'Umiestnenie'}
                                 value={get_place(data)} onChange={updateAddress}/>
                    <SelectInput options={data.Stav_options} name={'Stav'} label={'Stav Zápožičky'}
                                 value={data.Stav}
                                 onChange={update}/>
                    <SelectInput options={getLoanTypeOptions()} name={'Typ_Zapozicky'} label={'Typ Zápožičky'}
                                 value={data.Typ_Zapozicky} onChange={updateLoanType}/>
                    <DateInput name={'Odhad_Vratenia'} label={'Odhad Vrátenia'} value={data.Odhad_Vratenia}
                               onChange={update}/>
                </TwoColumnRows>
                <InstrumentLoanSection deleteInstrument={deleteInstrument}
                                       selectInstrument={selectInstrument}
                                       data={data} update={update}/>
                <RichTextInput name={'Poznamka'} label={'Poznámka'} value={data.Poznamka}
                               onChange={update}/>
                <InternalNote name={'Interna_Poznamka'} label={'Interná Poznámka'}
                               value={data.Interna_Poznamka}
                               onChange={update}/>
                <MultiFileInput fileData={fileData} setFileData={setFileData} data={data}
                                onChange={changeNewFilePrint}/>
            </FormContext.Provider>
        </>
    }

    return (
        <GenericForm label="Zápožička"
                     labelNew="Pridať zápožičku"
                     baseUrl={baseUrl}
                     id={id}
                     formContent={formContent}
                     customSubmit={customSubmit}
                     contentType={'multipart/form-data'}
                     parseData={parseData}
                     parseFromData={parseFromData}
                     progressWhenSaving={true}
                     reloadDataAfterSave={true}
                     reportGeneration={"ZP"}
                     reportType="loan"
                     initalParams={initialParams}
        />
    )
}

export default LoanForm